import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./qr-code.module.scss";
import QRCode from "react-qr-code";
import x from "../../images/001-x.svg";
import facebook from "../../images/002-facebook.svg";
import linkedin from "../../images/006-linkedin.svg";
import instagram from "../../images/003-instagram.svg";

interface QrProps {
  title?: string;
  href: string;
  qrOnly?: boolean;
  sizeQr?: number;
  from?: "search" | "cities" | "products" | "companies";
  visibleLinks?: boolean;
}

export default function QrCode({
  title,
  href,
  qrOnly = false,
  sizeQr = 180,
  from,
  visibleLinks = true,
}: QrProps) {
  const { t } = useTranslation();
  let newHref = href;

  if (from === "cities" || from === "search") {
    const url = new URL(window.location.href);
    url.searchParams.set("fromQr", "true");
    newHref = url.toString();
  }

  return (
    <>
      {qrOnly ? (
        <QRCode
          value={newHref}
          fgColor={styles.qrColor}
          level="L"
          size={sizeQr}
        />
      ) : (
        <div className={styles.content}>
          <div className={styles.qr}>
            <h4>{title}</h4>
            <QRCode
              value={newHref}
              fgColor={styles.qrColor}
              level="L"
              size={sizeQr}
            />
            <p>{t("qr-code.scanInstruction")}</p>
          </div>
          {visibleLinks && (
            <div className={styles.share}>
              <p>{t("qr-code.shareLabel")}</p>
              <div className={styles.icons}>
                <img src={x} alt={t("qr-code.xAlt")} />
                <img src={facebook} alt={t("qr-code.facebookAlt")} />
                <img src={linkedin} alt={t("qr-code.linkedinAlt")} />
                <img src={instagram} alt={t("qr-code.instagramAlt")} />
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
}
